import { useMotionValueEvent, useScroll, useTransform } from 'framer-motion';
import { useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

const animationBreakpoints = {
  desktop: {
    initial: 500,
    final: 520,
  },
  mobile: {
    initial: 150,
    final: 210,
  },
  tablet: {
    initial: 150,
    final: 210,
  },
};

export const useNavbarAnimations = ({ isDesktop }: { isDesktop: boolean }) => {
  const { scrollY } = useScroll();
  const { width: windowWidth } = useWindowSize();
  const viewport = isDesktop
    ? 'desktop'
    : windowWidth >= 768
      ? 'tablet'
      : 'mobile';

  const [isCTAHidden, setIsCTAHidden] = useState(false);

  //  Logo should start to animate before CTA, so logo is fully visible - JUST mobile.
  const logoBreakpoints = [
    animationBreakpoints.mobile.initial - 60,
    animationBreakpoints.mobile.initial,
  ];

  useMotionValueEvent(scrollY, 'change', (latest) => {
    // Used to update `visibility` css property, since opacity just hides it but not removes it from the DOM.
    if (latest <= animationBreakpoints[viewport].initial) {
      setIsCTAHidden(true);
      return;
    }

    setIsCTAHidden(false);
  });

  const ctaOpacity = useTransform(
    scrollY,
    [
      animationBreakpoints[viewport].initial,
      animationBreakpoints[viewport].final,
    ],
    [0, 1],
  );

  //  Cart animation - JUST mobile.
  const cartIconOpacity = useTransform(scrollY, logoBreakpoints, [1, 0]);

  const moveLogo = useTransform(scrollY, logoBreakpoints, [
    `${windowWidth / 2}px`,
    viewport === 'mobile' ? '115px' : '150px',
  ]);

  const scaleLogo = useTransform(scrollY, logoBreakpoints, [
    1,
    viewport === 'mobile' ? 0.7 : 0.9,
  ]);

  return {
    ctaOpacity,
    cartIconOpacity,
    moveLogo,
    scaleLogo,
    isCTAHidden,
  };
};
